// Legacy code, just modularized

import $ from 'jquery';
import noUiSlider from 'nouislider';

var restaurantListFilters = [];
var serviceSearchIsLoaded = false;
var restaurants = window.restaurants;
// Map variables
var map = null;
var markers = [];
var mapBounds = [];
var InfoWindows = {};

function createConferenceRoomSlider(slider, max) {

  var currentMin = $('#headcount-slider').data('headcountmin-current');
  var currentMax = $('#headcount-slider').data('headcountmax-current');

  noUiSlider.create(slider, {
    start: [
      typeof currentMin !== 'undefined' ? currentMin : 1,
      typeof currentMax !== 'undefined' ? currentMax : max
    ],
    connect: true,
    step: 1,
    range: {
      'min': 1,
      'max': max
    }
  });

  // If not in Kallion Kortteli service-search filtering system is used and headcount filter needs to be added.
  if (!isKallionKortteliTheme()) {
    // Adds filter for headcount
    addFilter('headcount',{min: currentMin,max: currentMax});
  }

  $('#headcount-slider .noUi-handle-lower').append('<span class="min-selection"></span>');
  $('#headcount-slider .noUi-handle-upper').append('<span class="max-selection"></span>');

  var valueContainer = [
    $('#headcount-slider .noUi-handle-lower .min-selection'),
    $('#headcount-slider .noUi-handle-upper .max-selection')
  ];

  slider.noUiSlider.on('update', function(values, handle) {
    valueContainer[handle].html( Number(values[handle]).toFixed(0) + ' Henkilöä');
    if( handle === 0 ) {
      $('#headcount-slider').attr('data-headcountmin', Number(values[handle]).toFixed(0) )
    }
    if( handle === 1 ) {
      $('#headcount-slider').attr('data-headcountmax', Number(values[handle]).toFixed(0) )
    }
    showConferenceRooms();
  });
}

function conferenceRoomSearch() {
  var slider = document.getElementById('headcount-slider');
  var maxVal = $('#headcount-slider').data('headcountmax');

  if(slider) {
    createConferenceRoomSlider(slider, maxVal);
  }

  $('.headcount-slider .show-all').on('click',function() {
    slider.noUiSlider.destroy()
    maxVal = $(this).find('span').data('max');
    createConferenceRoomSlider(slider, maxVal);
    $('.cards .card-holder').css('display', 'block');
  });
}

function showConferenceRooms() {

  var roomsVisible = 0;
  var headCount = 0;

  var min = parseInt($('#headcount-slider').attr('data-headcountmin'));
  var max = parseInt($('#headcount-slider').attr('data-headcountmax'));

  // If not in Kallion Kortteli
  if (!isKallionKortteliTheme()) {
    // These functions are global and located in service-search.js.
    updateFilter('headcount',{min: min,max: max});
    if (serviceSearchIsLoaded) {
      filterRestaurantItems();
    }
    updateRestarauntListElementsCss();
    roomsVisible = $('.restaurant-list-results-list .restaurant-list-item.show').length;
  // In Kallion Kortteli
  } else {
    var $conferenceRooms = $('.cards .card, .restaurant-list-results .restaurant-list-item');
    $.each($conferenceRooms, function(index, conferenceRoom) {
      headCount = parseInt($(conferenceRoom).data('headcount'));
      // Conference room headcount matches
      if(min <= headCount && max >= headCount) {
        $(conferenceRoom).parent().css('display', 'block');
        roomsVisible++;
      // Conference room headcount doesn't match
      } else {
        $(conferenceRoom).parent().css('display', 'none');
      }
    });
  }

  // There are multiple selectors because headcount slider appears in multiple pages where html structure is different
  var $roomsHeader = $('.service-mainlist .room-count, #realTimeCount');
  $roomsHeader.html(roomsVisible);

}

/**
 * In some cases we need to check is the page Kallion Kortteli
 *
 * @return {Boolean} Boolean that indicates if we are in Kallion Kortteli
 */
function isKallionKortteliTheme() {
  return $('body').hasClass('theme-kallionkortteli');
}

/**
 * Updates filter by given type. Function removes the object and after that it adds it again with a new value.
 *
 * @param {String} type - Type of the filter.
 * @param {Object} val - Value of filter object which can be anything for example string or object.
 */
function updateFilter(type,val) {
  removeFilterByType(type);
  addFilter(type,val);
}

/**
 * Adds filter to global restaurantListFilters object.
 *
 * @param {String} type - Type of the filter.
 * @param {Object} val - Value of filter object which can be anything for example string or object.
 */
function addFilter(type,val) {
  restaurantListFilters.push(
    {
      type: type,
      val: val
    }
  );
}

/**
 * Removes filter from global restaurantListFilters object by type.
 *
 * @param {String} type - Type of the filter.
 */
function removeFilterByType(type) {
  var searchInd = -1;
  for(var i = 0; i < restaurantListFilters.length; i++) {
    if(restaurantListFilters[i].type === type) {
      searchInd = i;
      break;
    }
  }
  if(searchInd > -1) {
    restaurantListFilters.splice(searchInd, 1);
  }
}

/**
 * Updates restaurant list css.
 * EDIT 24.5.2019: This is legacy function. Added headcount selector functionality.
 */
function updateRestarauntListElementsCss() {
  // Remove css from all items.
  $('.restaurant-list-item').css({
    width: '',
    'margin-left': ''
  });
  if($(window).width() >= 768) {
    // Get lists. There might be more than one restaurant list in page. For example other spaces of restaurant and last seen restaurants.
    var lists = $('.restaurant-list-results-list');
    lists.each(function(i) {
      // Get this list items.
      var list = $(lists[i]).find('.restaurant-list-item.show');
      if(list.length > 0) {
        // Add style for list item.
        list.css({
          width: 'calc(33.33% - 14px)',
          'margin-left':  '20px'
        });
        // Remove margin from the item which is in the beginning of the row.
        list.each(function(i) {
          if(i % 3 === 0) {
            $(this).css('margin-left', '');
          }
        });
      }
    })
  }
}

/**
 * There is global restaurants object and with this function it is possible to update one property with given value
 * to every restaurant in the object.
 *
 * @param {string} key - Object property key
 * @param {string} val - Value for the object property
 */
function updateALLRestaurantData(key, val) {
  for(var i = 0; i < restaurants.length; i++) {
    restaurants[i][key] = val;
  }
}

/**
 * Shows restaurants based on search page's filters
 */
function filterRestaurantItems() {
  $('.restaurant-list-item').removeClass('show').removeClass('cannot-show');
  updateALLRestaurantData('show', false);

  var rf = [];
  var services = [];
  var cities = [];
  var types = [];
  var type = null;
  var val = null;
  var getParams = {};
  var stopFiltering = false; //optimization

  function findOne(haystack, arr) {
    return arr.some(function(v) {
      return haystack.indexOf(v) >= 0;
    });
  }

  //modify restaurantlistfilters first:
  //want to all services options to same object so we can filter element properly
  for(var k = 0; k < restaurantListFilters.length; k++) {
    type = restaurantListFilters[k].type;
    val = restaurantListFilters[k].val;
    if(type === 'services') {
      services.push(val);
    }
    else if(type === 'city') {
      cities.push(val);
    }
    else if(type === 'school' || type === 'nursery') {
      types.push(type);
    }
    else if(type ==='headcount') {
      rf.push(
        {
          type: 'headcount',
          val: {
            min: parseInt(val.min),
            max: parseInt(val.max)
          }
        }
      );
    }
  }
  if(cities.length) {
    rf.push(
      {
        type: 'city',
        val: cities
      }
    );
  }
  if(services.length) {
    rf.push(
      {
        type: 'services',
        val: services
      }
    );
  }
  if(types.length) {
    rf.push(
      {
        type: 'schoolOrNursery',
        val: types
      }
    );
  }

  // Loop restaurant filters and change show propert of restaurant based on filtering
  for(k = 0; k < rf.length; k++) {
    type = rf[k].type;
    val = rf[k].val;
    if(type === 'city') {
      $('.restaurant-list-item').each(function() {
        if(!$(this).hasClass('cannot-show')) {
          var city = $(this).data('city');
          if(val.indexOf(city) >= 0) {
            $(this).addClass('show');
            updateRestaurantData($(this).attr('id'), 'show', true);
          }
          else {
            $(this).removeClass('show');
            $(this).addClass('cannot-show');
            updateRestaurantData($(this).attr('id'), 'show', false);
          }
        }
      });
      if(typeof getParams.city === 'undefined') {
        getParams.city = {
          fields: []
        };
      }
      getParams.city.fields.push(val);
    }
    else if(type === 'services') {
      $('.restaurant-list-item').each(function() {
        if(!$(this).hasClass('cannot-show')) {
          var services = String($(this).data('services')).split(' ');

          if(findOne(val, services)) {
            $(this).addClass('show');
            updateRestaurantData($(this).attr('id'), 'show', true);
          }
          else {
            $(this).removeClass('show');
            $(this).addClass('cannot-show');
            updateRestaurantData($(this).attr('id'), 'show', false);
          }
        }
      });
      if(typeof getParams.services === 'undefined') {
        getParams.services = {
          fields: []
        };
      }
      getParams.services.fields.push(val);
    }
    else if(type === 'schoolOrNursery') {
      $('.restaurant-list-item').each(function() {
        if(!$(this).hasClass('cannot-show')) {
          var ptype = $(this).data('ptype');
          if(val.indexOf(ptype) >= 0) {
            $(this).addClass('show');
            updateRestaurantData($(this).attr('id'), 'show', true);
          }
          else {
            $(this).removeClass('show');
            $(this).addClass('cannot-show');
            updateRestaurantData($(this).attr('id'), 'show', false);
          }
        }
      });
      for(var j = 0; j < val.length; j++) {
        if(val[j] === 'school') {
          if(typeof getParams.school === 'undefined') {
            getParams.school = {
              fields: []
            };
          }
          getParams.school.fields.push(val[j]);
        }
        if(val[j] === 'nursery') {
          if(typeof getParams.nursery === 'undefined') {
            getParams.nursery = {
              fields: []
            };
          }
          getParams.nursery.fields.push(val[j]);
        }
      }
    } else if (type === 'headcount') {
      $('.restaurant-list-item').each(function() {
        // Check headcount filter if passed other filters
        if (!$(this).hasClass('cannot-show')) {
          var restaurantHeadcount = parseInt($(this).data('headcount'));
          // If restaurant headcount matches and show it
          if ( restaurantHeadcount >= val.min && restaurantHeadcount <= val.max ) {
            $(this).addClass('show');
            updateRestaurantData($(this).attr('id'), 'show', true);
            // Otherwise do not show
          } else {
            $(this).removeClass('show');
            $(this).addClass('cannot-show');
            updateRestaurantData($(this).attr('id'), 'show', false);
          }
        }
      });
      if(typeof getParams.headcount === 'undefined') {
        getParams.headcount = {
          fields: []
        };
      }
      getParams.headcount.fields.push(val.min);
      getParams.headcount.fields.push(val.max);
    }
  }



  if(restaurantListFilters.length === 0 && !stopFiltering) {
    $('.restaurant-list-item').addClass('show');
    updateALLRestaurantData('show', true);
  }

  var itemCounter = $('.restaurant-list-item.show').length / 2; //we have 2 list to same items so thats why
  $('#realTimeCount').text(itemCounter);

  updateRestarauntListElementsCss();

  //update map markers
  if(typeof markers !== 'undefined' && markers.length > 0) {
    clearMarkers();
    addMarkersToMap(restaurants);
  }

  //update url
  // detect history.replaceState support
  if(window.history && window.history.replaceState) {
    var extraParams = '';
    if(Object.keys(getParams).length > 0) {
      extraParams = '?';
      for(var key in getParams) {
        extraParams += key + '=' + getParams[key].fields.join(',') + '&';
      }
      extraParams = extraParams.slice(0, -1);
    }

    var pathname = location.pathname;
    window.history.replaceState('', $(document).attr('title'), pathname + extraParams);
  }
}

/**
 * Clears markers from the restaurant search page's map.
 */
function clearMarkers() {
  for(var i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }
  markers = [];
  mapBounds = new window.google.maps.LatLngBounds();
}

/**
 * There is global restaurants object and with this function it is possible to update one property with given value
 * to every restaurant in the object.
 *
 * @param {string} id - Restaurant slug.
 * @param {string} key - Object property key.
 * @param {string} val - Value for the object property.
 * @return {boolean} Returns true if restaurant id exists.
 */
function updateRestaurantData(id, key, val) {
  for(var i = 0; i < restaurants.length; i++) {
    if(id === restaurants[i].slug) {
      restaurants[i][key] = val;
      return true;
    }
  }
  return false;
}

/**
 * Adds markers to the search page's map
 *
 * @param {Object} locations - Restaurants which should be added if show property is true.
 */
function addMarkersToMap(locations) {

  function parseAttrsFromUrl(url) {

    var retVal = false;
    var attrs;
    var parseFailed;

    if(typeof url === 'undefined' || !url ) return retVal;

    if(url.indexOf('/@') !== -1 ) {
      attrs = url.match(/@([^;]*)\//);

      if(attrs[1]) {
        attrs = String(attrs[1]).split(',');
        $.each(attrs,function(i,attr) {
          attrs[i] = Number(attr.replace(/[^0-9.-]/g, ''));
          if(isNaN(attrs[i])) parseFailed = true;
          // Note: tilt is different @ google maps and in static view. level tilt @ google maps = 90, level tilt @ streetview images = 0
          if(i === 5 && !isNaN(attrs[i])) attrs[i] = (attrs[i] - 90);
        });

        if(!parseFailed) retVal = attrs;
      }
    }

    return retVal;

  } // parseAttrsFromUrl

  if(typeof google !== 'undefined') {

    clearMarkers();
    var marker = null;
    var infoWindow = null;
    var position = null;
    var image;
    var location_icon;
    var lunch_icon;
    var lunch_addr;
    var mapQuery;

    for(var i = 0; i < locations.length; i++) {

      if(locations[i].lat && locations[i].lng && locations[i].show === true) {

        position = new window.google.maps.LatLng( locations[i].lat, locations[i].lng );
        image = '';

        // if streetview url is defined, parse necessary data from it and add streetview image to infoWindow
        if(locations[i].google_streetview_url ) {
          var attrs = parseAttrsFromUrl( locations[i].google_streetview_url );
          if(attrs) {
            image = '<div class="marker-image" style="background-image:url(\'https://maps.googleapis.com/maps/api/streetview?size=600x300&location=' + attrs[0] + ',' + attrs[1] + '&heading=' + attrs[4] + '&pitch=' + attrs[5] + '&key=AIzaSyBuMxfPYpKfRli5eggI7AEYU9qiRjGQuks\');"></div>';
          }
        }

        location_icon = locations[i].location_icon;
        lunch_icon = locations[i].lunch_icon;
        mapQuery = typeof locations[i].mapQuery !== 'undefined' && locations[i].mapQuery ? locations[i].mapQuery : '//maps.google.com?daddr=' + locations[i].lat + ',' + locations[i].lng;
        lunch_addr = typeof locations[i].page !== 'undefined' ? locations[i].page : '#';

        var content = '<div class="marker-infowindow">' + image + '<div><a href="' + locations[i].slug + '" class="marker-title">' + locations[i].name + '</a></div>' + '<span class="marker-address">' + locations[i].street_address + ', ' + locations[i].post_code + ' ' + locations[i].city + '</span><div class="marker-buttons"><a class="directions" href="' + mapQuery + '" target="_blank">' + location_icon + '<span>' + getText('ROUTE_INFO') + '</span></a>';
        if(getText('LUNCH_LIST') !== '') {
          content += '<a class="lunchMenu js" href="' + lunch_addr + '">' + lunch_icon + '<span>' + getText('LUNCH_LIST') + '</span></a>';
        }
        content += '</div></div>';

        infoWindow = new window.google.maps.InfoWindow({
          content: content,
          slug: locations[i].slug
        });

        marker = new window.google.maps.Marker({
          html: content,
          position: position,
          map: map,
          slug: locations[i].slug,
          icon: 'https://palmia.studio.crasman.fi/pub/web/img/location-marker.png'
        });

        var currentMarker;

        marker.addListener('click', function() {
          infoWindow.setContent(this.html);
          infoWindow.open(map, this);
          currentMarker = this;
          $('.restaurant-list-item').find('.showOnMap').removeClass('active');
          $('#' + this.slug).find('.showOnMap').addClass('active');
        });

        InfoWindows[locations[i].slug] = {
          infoWindow: infoWindow,
          marker: marker,
          open: false
        }


        window.google.maps.event.addListener(infoWindow,'closeclick',function() {
          var markerId;
          if(typeof currentMarker !== 'undefined') {
            markerId = currentMarker.slug;
          } else {
            markerId = this.slug;
          }
          $('#' + markerId).find('.showOnMap').removeClass('active');
          InfoWindows[this.slug].infoWindow.close(map, InfoWindows[this.slug].marker);
          InfoWindows[this.slug].open = false;
        });

        mapBounds.extend(position);
        markers.push(marker);
      }
    }

    // Skaalaa kartta niin että kaikki pisteet näkyvät
    map.fitBounds(mapBounds);
  }
}

function getText(key) {
  if(typeof window.texts === 'undefined' || typeof window.texts[key] === 'undefined') {
    return '';
  }
  return window.texts[key];
}

//----------------

const conferenceRoomSearchMod = {
  init: function() {

    // Old service-search.js file contents...

    var currentMenuLng = 2;


    /**
 * Removes filter from global restaurantListFilters object by type and value.
 *
 * @param {String} type - Type of the filter.
 * @param {Object} val - Value of filter object which can be anything for example string or object.
 */
    function removeFilter(type,val) {
      var searchInd = -1;
      for(var i = 0; i < restaurantListFilters.length; i++) {
        if(restaurantListFilters[i].type === type &&
      restaurantListFilters[i].val === val) {

          searchInd = i;
          break;
        }
      }
      if(searchInd > -1) {
        restaurantListFilters.splice(searchInd, 1);
      }
    }

    $(function() {

      var restaurantArray = [];
      $.each(restaurants, function(k,v) {
        restaurantArray.push(v.name.trim());
      });
      var restaurantNames = restaurantArray.join(';');

      String.prototype.toUpperFirst = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
      }

      function fixTypo(inputField,targets,searchTerm,outputElement) {
        targets = String(targets);
        var names = targets.toLowerCase().split(';');
        var matchFound = false;
        var restaurants = [];

        for(var i = 0; i < names.length; i++) {
          restaurants.push({name: names[i]});
        }

        if(searchTerm.length > 1) {
          $.each(restaurants, function(k,v) {
            var typosOutput = '';
            var typo_a = [];
            for(var i = 0; i < v.name.length; i++) {
              var typos = new RegExp(searchTerm.toLowerCase().slice(0,i) + '(.)' + searchTerm.toLowerCase().slice(i), 'i');
              typosOutput = v.name.match(typos);
              var searchTermRegex = new RegExp('^' + searchTerm + '$', 'g');

              if(v.name.match(searchTermRegex) && $('.restaurant-list .restaurant-list-item').length !== 0) {
                outputElement.html('');
              } else if(typosOutput && matchFound === false) {
                typo_a.push(typosOutput.input);
                matchFound = true;
                outputElement.html('Tarkoititko: <span class="typo-fix" style="text-decoration:underline;color:#e94d09;cursor:pointer;">' + typo_a[0].toUpperFirst() + '</span>');
              }
            }
          });
        } else {
          outputElement.empty();
        }

        $('.typo-fix').on('click', function() {
          $('.restaurant-filter-buttons').find('a').removeClass('active');
          $('.restaurant-filter-buttons').find('a.all').addClass('active');
          inputField.val($(this).text());
          searchRestaurants($('.restaurant-filter-buttons').find('.active').data('filter'));
          outputElement.empty();
        });
      }

      function scrollMap() {
        var map             = $('#restaurants-map');
        var scrollDistance  = $(window).scrollTop();
        var beginAfter      = $('.restaurant-list-container:first').offset();

        // this controls map's MAX HEIGHT value.
        // max-height is active only used when page is at top or middle of page.
        // when footer comes visible, then 'height' makes map smaller
        var mh = $('#restaurants-map').offset().top - $(window).scrollTop();
        if(mh < 0) mh = 0;
        $('#restaurants-map').css('max-height',Math.max(window.innerHeight - mh));

        if(scrollDistance < beginAfter.top) {
          map.css({position: 'relative'}).removeClass('fixed');
          // map.css('top', 0 );
        } else if(scrollDistance > beginAfter.top) {
          map.css({
            position: 'fixed',
            top: 0
          }).addClass('fixed');
          // map.css('top', top );
        }
      }

      // Google maps for restaurant page
      function initialize() {

        map = new window.google.maps.Map(document.getElementById('restaurants-map-canvas'), {
          maxZoom: 13,
          mapTypeControl: false,
          streetViewControl: false,
          rotateControl: false,
          zoomControl: true
        });

        mapBounds = new window.google.maps.LatLngBounds();
        // Add initial markers
        addMarkersToMap(restaurants);

        map.set('styles', [
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e9e9e9'
              },
              {
                lightness: 17
              }
            ]
          },{
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5'
              },
              {
                lightness: 20
              }
            ]
          },{
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 17
              }
            ]
          },{
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 29
              },
              {
                weight: 0.2
              }
            ]
          },{
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 18
              }
            ]
          },{
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 16
              }
            ]
          },{
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5'
              },
              {
                lightness: 21
              }
            ]
          },{
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
              {
                color: '#dedede'
              },
              {
                lightness: 21
              }
            ]
          },{
            elementType: 'labels.text.stroke',
            stylers: [
              {
                visibility: 'on'
              },
              {
                color: '#ffffff'
              },
              {
                lightness: 16
              }
            ]
          },{
            elementType: 'labels.text.fill',
            stylers: [
              {
                saturation: 36
              },
              {
                color: '#333333'
              },
              {
                lightness: 40
              }
            ]
          },{
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },{
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f2f2f2'
              },
              {
                lightness: 19
              }
            ]
          },{
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#fefefe'
              },
              {
                lightness: 20
              }
            ]
          },{
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#fefefe'
              },
              {
                lightness: 17
              },
              {
                weight: 1.2
              }
            ]
          }
        ]);

        function fluidMapSize() {

          $('#restaurants-map').css('padding-bottom',0);

          var winPos = $(window).scrollTop();
          var winHeight = $(window).height();
          var mapPos = $('#restaurants-map').offset().top;
          var mapHeightFluid = (winHeight + winPos) - mapPos;

          var restListHeight = $('.restaurant-list').height();
          var restListPos = $('.restaurant-list').offset().top;
          var footerSpace = (winHeight + winPos) - (restListHeight + restListPos);

          if(mapHeightFluid > 360 && footerSpace <= 0) {
            $('#restaurants-map').height(mapHeightFluid);
          } else if(footerSpace > 0) {
            $('#restaurants-map').height(mapHeightFluid - footerSpace);
          }

          window.google.maps.event.trigger(map, 'resize');

          if(map && mapBounds) {
            map.fitBounds(mapBounds);
          }
        }
        fluidMapSize();

        // Google maps resize event
        $(window).on('resize', function() {
          window.google.maps.event.trigger(map, 'resize');
          if(map && mapBounds) {
            map.fitBounds(mapBounds);
          }
          //   $('#restaurants-map').width($(window).width()-$('#restaurants-map').offset().left);
          $('#restaurants-map').css('width',$('#restaurants-map').parent().width());
        });

        // Resize map by scrolling until it's full height
        $(window).scroll(function() {
          fluidMapSize();
        });

      }

      // Restaurant search
      function searchRestaurants(filter) {
        if(!$('.loading').length) {
          $('.search-dropdown .search-item-container').before('<div class="loading"></div>');
        }

        //var final_result = '';
        var serviceFilter = filter ? filter : 'all';

        $.ajax({
          type: 'GET',
          url: '/stage-ajax/searchRestaurants',
          data: {
            lang: $('html').attr('lang'),
            search: $('#searchRestaurant').val().replace(/[^\w\såäö\u0400-\u04FF-]/g, '').trim(),
            filter: serviceFilter
          },
          success: function(resp) {
            search(resp);
          }
        });

        function search(resp) {
          var searchArray = false;
          var i = false;

          addMarkersToMap(resp);

          $('.loading').remove();
          searchArray = $('#searchRestaurant').val().replace(/[^\w\såäö\u0400-\u04FF-]/g, '').replace(/\s+(?= )/g, '').trim().split(' ');
          for(i = 0; i < searchArray.length; i++) {
            $('.restaurant-list .restaurant-list-item .restaurant-name a').highlight(searchArray[i], 'hilite');
          }
          if(serviceFilter === 'lunch') {
            $('.restaurant-list-title').text(getText('RESTAURANT_CATEGORY_LUNCH_PLURAL')); // 'Lounasravintolat'
          }
          else if(serviceFilter === 'meeting') {
            $('.restaurant-list-title').text(getText('RESTAURANT_CATEGORY_MEETING_PLURAL')); // 'Kokouspaikkaravintolat'
          }
          else if(serviceFilter === 'party') {
            $('.restaurant-list-title').text(getText('RESTAURANT_CATEGORY_PARTY_PLURAL')); // 'Juhlatilaravintolat'
          }
          else {
            $('.restaurant-list-title').text(getText('RESTAURANT_CATEGORY_ALL')); // 'Kaikki ravintolat'
          }
          $('.restaurant-list-resultCount').text('Löysimme ' + $('.restaurant-list .restaurant-list-item').length + ' ravintolaa.');
        }
      }

      $('#searchRestaurant').on('input', function() {
        var $self = $(this);
        // clearTimeout(inputTimeout);
        // inputTimeout = setTimeout(searchRestaurants($('.restaurant-filter-buttons').find('.active').data('filter')), 500);
        searchRestaurants($('.restaurant-filter-buttons').find('.active').data('filter'));
        fixTypo($('#searchRestaurant'), restaurantNames, $self.val(), $('#rec'));
      });

      $('.restaurant-filter-buttons').find('a').on('click', function(e) {
        e.preventDefault();
        var $self = $(this);
        if(!$self.hasClass('active')) {
          $('.restaurant-filter-buttons').find('a').removeClass('active');
          $self.addClass('active');
          searchRestaurants($self.data('filter'));
        }
      });

      // Show on map functionality
      $('.container').on('click', '.showOnMap', function(e) {

        // if no lat or long is available: open google maps using link address
        if( $(this).hasClass('no-lat') || $(this).hasClass('no-lng') ) return true;
        // map is missing or not visible (mobile devices): open google maps using link address
        else if( !$('#restaurants-map').length || $('#restaurants-map').is(':hidden')) return true;

        e.preventDefault();

        var $self = $(this);
        var slug = $self.data('slug');
        if( !InfoWindows[slug].open ) {
          InfoWindows[slug].infoWindow.open(map, InfoWindows[slug].marker);
          InfoWindows[slug].open = true;
          $self.addClass('active');
        } else {
          InfoWindows[slug].infoWindow.close(map, InfoWindows[slug].marker);
          InfoWindows[slug].open = false;
          $self.removeClass('active');
        }

      });

      function imgHeightRestaurantPage() {
        if($('#js-title-image').length <= 0 || $('.body-text').find('.restaurant-info-table').length <= 0) {
          return;
        }
        if($('.body-text').find('.restaurant-info-table').offset().top === $('#js-title-image').offset().top) {
          $('#js-title-image').height($('.body-text').find('.restaurant-info-table').height());
        } else {
          $('#js-title-image').height(300);
        }
      }

      if($('.body-text').find('.restaurant-info-table').length) {
        imgHeightRestaurantPage();
        $(window).resize(function() {
          imgHeightRestaurantPage()
        });
      }

      // move map when scrolling
      if($('#restaurants-map').length) {
        $(window)
          .on('scroll',function() {
            scrollMap();
          })
          .on('resize',function() {
            /*var map = */$('#restaurants-map').css('padding-bottom',0);
          })
          .trigger('resize')
          .trigger('scroll');
      }

      // filter map results if page was loaded with category request
      if( typeof window.mapType !== 'undefined' ) $('.restaurant-filter-buttons a[data-filter="' + window.mapType + '"]').click();

      //filter + sorter buttons
      $('#locationFirstSort').click(function() {
        $(this).addClass('selected');
        $('#charsFirstSort').removeClass('selected');

        //real logic
        var numericallyOrderedDivs = $('.restaurant-list-results-list .restaurant-list .restaurant-list-item').sort(function(a, b) {

          return $(a).children('.restaurant-list-item-text-container').children('.restaurant-list-item-distance').data('distance') -
              $(b).children('.restaurant-list-item-text-container').children('.restaurant-list-item-distance').data('distance');
        });
        $('.restaurant-list-results-list .restaurant-list').empty().html(numericallyOrderedDivs);

        numericallyOrderedDivs = $('.restaurant-list-results-map .restaurant-list .restaurant-list-item').sort(function(a, b) {

          return $(a).children('.restaurant-list-item-distance').data('distance') - $(b).children('.restaurant-list-item-distance').data('distance');
        });
        $('.restaurant-list-results-map .restaurant-list').empty().html(numericallyOrderedDivs);

        filterRestaurantItems();
      });
      $('#charsFirstSort').click(function() {
        $(this).addClass('selected');
        $('#locationFirstSort').removeClass('selected');

        //real logic
        var alphabeticallyOrderedDivs = $('.restaurant-list-results-list .restaurant-list .restaurant-list-item').sort(function(a, b) {
          var aText = $(a).children('.restaurant-list-item-text-container').children('.restaurant-list-item-name').text().toUpperCase();
          var bText = $(b).children('.restaurant-list-item-text-container').children('.restaurant-list-item-name').text().toUpperCase();
          if(aText < bText) {
            return -1;
          }
          else if(aText > bText) {
            return 1;
          }
          return 0;
        });
        $('.restaurant-list-results-list .restaurant-list').html(alphabeticallyOrderedDivs);

        alphabeticallyOrderedDivs = $('.restaurant-list-results-map .restaurant-list .restaurant-list-item').sort(function(a, b) {
          var aText = $(a).children('.restaurant-list-item-name').text().toUpperCase();
          var bText = $(b).children('.restaurant-list-item-name').text().toUpperCase();
          if(aText < bText) {
            return -1;
          }
          else if(aText > bText) {
            return 1;
          }
          return 0;
        });
        $('.restaurant-list-results-map .restaurant-list').html(alphabeticallyOrderedDivs);

        filterRestaurantItems();
      });
      $('#mapSort').click(function() {
        $(this).addClass('selected');
        $('#listSort').removeClass('selected');

        //real logic
        $('.restaurant-list-results-map').addClass('selected');
        $('.restaurant-list-results-list').removeClass('selected');
        if(map === null) {
          if($('#restaurants-map').length) {
            setTimeout(function() {
              $('#restaurants-map').css('width',$('#restaurants-map').parent().width());
              var gMapsLoaded = false;

              window.gMapsCallback = function() {
                gMapsLoaded = true;
                $(window).trigger('gMapsLoaded');
              };

              window.loadGoogleMaps = function() {
                if(gMapsLoaded) return window.gMapsCallback();
                var script_tag = document.createElement('script');
                script_tag.setAttribute('type','text/javascript');
                script_tag.setAttribute('src','https://maps.googleapis.com/maps/api/js?key=AIzaSyCaEyfXwM5YII5VKjy_SMV6geh8yAWBeuw&callback=gMapsCallback');
                (document.getElementsByTagName('head')[0] || document.documentElement).appendChild(script_tag);
              };
              $(window).bind('gMapsLoaded', initialize);
              window.loadGoogleMaps();

            }, 1000);
          }

        }
      });
      $('#listSort').click(function() {
        $(this).addClass('selected');
        $('#mapSort').removeClass('selected');

        //real logic
        $('.restaurant-list-results-map').removeClass('selected');
        $('.restaurant-list-results-list').addClass('selected');
      });
      $('.restaurant-filter-button-title').click(function() {
        $(this).toggleClass('show').parent().children('.restaurant-filter-button-options').toggleClass('show');
        if($(this).hasClass('show')) {
          var that = $(this);
          setTimeout(function() {
            $('body').click(function(e) {
              if(!$(e.target).hasClass('restaurant-filter-button-option') && !$(e.target).hasClass('restaurant-filter-button-option-checkbox') &&
              !$(e.target).hasClass('restaurant-filter-button-option-text')) {
                that.removeClass('show').parent().children('.restaurant-filter-button-options').removeClass('show');
                $('body').off('click');
              }
            });
          }, 100);
        }
        else {
          $('body').off('click');
        }
      });

      // Initializes click function for meeting and party restaurant's reserve button.
      $('.invidual-restaurant-button.reserve-restaurant-button').on('click', function() {
        // Scroll to reserve request form.
        $('html,body').animate({scrollTop: $('.content-block.contact-form').offset().top},800);
      });

      // Initializes click function for meeting and party restaurant's check other spaces button.
      $('.check-other-spaces-link').on('click', function() {
        // Scroll to restaurant's other spaces scriptlet.
        $('html,body').animate({scrollTop: $('.restaurant-other-spaces').offset().top},800);
      });

      // Updates filters when options are selected or deselected
      $('.restaurant-filter-button-option, .restaurant-filter-button-option-image').click(function() {
        var mode = 'add';
        var logicMode = 'normal';
        if($(this).hasClass('restaurant-filter-button-option-image')) {
          logicMode = 'schoolCheckboxes';
          //school checkboxes working different logic than other button fields
        }
        if($(this).hasClass('checked')) {
          mode = 'remove';
        }
        $(this).toggleClass('checked');
        if(logicMode === 'normal') {
          //need only normal mode
          var counter = $(this)
            .parent().parent()
            .children('.restaurant-filter-button-counter');

          var c = $(this).parent().children('.restaurant-filter-button-option.checked, .restaurant-filter-button-option-image.checked').length;
          if(c === 0) {
            counter.removeClass('show');
          }
          else {
            counter.addClass('show');
            counter.text('' + c);
          }
        }

        //real logic
        var type = $(this).data('optiontype');
        var val = '';
        if($(this).hasClass('restaurant-filter-button-option')) {
          val = $(this).data('value');
        }
        else {
          val = $(this).attr('value');
        }

        var text = '';
        if(logicMode === 'normal') {
          text = $(this).children('.restaurant-filter-button-option-text').text();
        }
        else {
          var fullText = $(this).parent().children('.restaurant-filter-button-option-text').text();
          var index = fullText.indexOf(' ');
          fullText = fullText.substring(index + 1);
          text = fullText.charAt(0).toUpperCase() + fullText.slice(1);
        }

        if(mode === 'add') {

          var element = '<div class="restaurant-list-heading-filters-item" data-optiontype="' + type + '" data-value="' + val + '">' + text + '</div>';

          $('.restaurant-list-heading-filters').prepend(element);
        }
        else if(mode === 'remove') {
          $('.restaurant-list-heading-filters .restaurant-list-heading-filters-item[data-optiontype="' + type + '"][data-value="' + val + '"]').remove();
        }

        //reset events
        $('.restaurant-list-heading-filters .restaurant-list-heading-filters-item').off('click').click(function() {
          var type = $(this).data('optiontype');
          var val = '';
          if($(this).hasClass('restaurant-list-heading-filters')) {
            val = $(this).attr('value');
          }
          else {
            val = $(this).data('value');
          }
          $('.restaurant-filter-button-option.checked[data-optiontype="' + type + '"][data-value="' + val + '"], .restaurant-filter-button-option-image.checked[data-optiontype="' + type + '"][value="' + val + '"]')
            .trigger('click');

        });

        //filter items
        if(mode === 'add') {
          addFilter(type,val);
        }
        else if(mode === 'remove') {
          removeFilter(type,val);
        }
        filterRestaurantItems();
      });

      $('.invidual-restaurant-tab-selection-btn').click(function() {
        $('.invidual-restaurant-tab-selection-btn').removeClass('selected');
        $('.invidual-restaurant-section-tab').removeClass('selected');
        $(this).addClass('selected');
        $('.invidual-restaurant-section-tab[data-sectiontype=' + $(this).data('btntype') + ']').addClass('selected');
      });
      function reloadThemesEvents() {
        $('.invidual-restaurant-themes-list-item').off('click').click(function() {
          if($(this).hasClass('open')) {
            $(this).removeClass('open');
          }
          else {
            $(this).addClass('open');
          }
        });
      }

      if($('#themesArea').data('filleddata') === false) {
        $('#themesArea').data('filleddata', true);
        reloadThemesEvents();
        $('.invidual-restaurant-themes-list-item').hide();
        var firstLink = $('.invidual-restaurant-themes-link').first();
        firstLink.addClass('selected');
        $('.invidual-restaurant-themes-list-item[data-ord="' + firstLink.data('ord') + '"]').show();
      }
      $('.invidual-restaurant-themes-link').click(function() {
        var ord = parseInt($(this).data('ord'));
        if(ord === null) return;

        $('.invidual-restaurant-themes-link').removeClass('selected');
        $(this).addClass('selected');

        $('.invidual-restaurant-themes-list-item').hide();
        $('.invidual-restaurant-themes-list-item[data-ord="' + ord + '"]').show();

      });

      //additional scripts
      $(':root').toggleClass('js',true);
      //additional scripts END

      // convert email links
      $('.jsConvertsThis[data-start][data-stop]').each(function() {
        var address = $(this).data('start') + '@' + $(this).data('stop');
        var href = 'mailto:' + address;

        $(this).attr('href',href).text(address);

      });

      updateRestarauntListElementsCss();
      $(window).resize(function() {
        updateRestarauntListElementsCss();
      });    

      function getUrlParameter(name) {
        name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      }

      var listOfParams = ['services', 'city', 'school', 'nursery'];
      var listOfElements = '';
      for(var i = 0; i < listOfParams.length; i++) {
        var param = getUrlParameter(listOfParams[i]);
        if(param !== '') {
          param = String(param);
          param = param.split(',');
          for(var k = 0; k < param.length; k++) {
            if(listOfParams[i] === 'school' || listOfParams[i] === 'nursery') {
              listOfElements += '.restaurant-filter-button-option-image[data-optiontype=' + listOfParams[i] + '][value=' + param[k] + '], ';
            }
            else {
              listOfElements += '.restaurant-filter-button-option[data-optiontype=' + listOfParams[i] + '][data-value=' + param[k] + '], ';
            }

          }
        }
      }
      if(listOfElements !== '') {
        listOfElements = listOfElements.slice(0, -2);
        $(listOfElements).trigger('click');
      }

      if($('#returnLink').length > 0) {
        //logic for back btn
        var refererr = document.referrer;
        if(refererr.indexOf('/ravintola/kouluhaku/') >= 0) {
          $('#returnLink').attr('href', refererr).text(window.trans.BACK_TO_SEARCH).show();
        }
        else if(refererr.indexOf('/ravintola/ajankohtaista/') >= 0) {
          $('#returnLink').attr('href', refererr).text(window.trans.BACK_TO_NEWS).show();
        }
        else if(refererr.indexOf('/ravintola/koulu/') >= 0) {
          if(refererr.indexOf('paivakoti') >= 0) {
            $('#returnLink').attr('href', refererr).text(window.trans.BACK_TO_NURSERY).show();
          }
          else {
            $('#returnLink').attr('href', refererr).text(window.trans.BACK_TO_SCHOOL).show();
          }

        }
        else if(refererr.indexOf('/ravintola/ravintola/') >= 0) {
          $('#returnLink').attr('href', refererr).text(window.trans.BACK_TO_RESTAURANT).show();
        }
      }

      // This is for schools search. If checkbox filters are checked based on request parameters
      // we need to add filters on page load so restaurant are filtered based on request parameters.
      if ($('#schoolsOnly').hasClass('checked')) {
        addFilter('school','open');
      }
      if ($('#nurseryOnly').hasClass('checked')) {
        addFilter('nursery','open');
      }

      // Filter restaurant items when page is loaded if there are filters.
      if (restaurantListFilters.length > 0) {
        filterRestaurantItems();
      }

      // Show more button for description text of search element.
      if ($('.restaurant-search .text-container .description').length > 0) {
        // Click function for show description.
        $('.restaurant-search .text-container .show-description').click(function() {
          // Remove button.
          $(this).remove();
          // Show description.
          $('.restaurant-search .text-container .description').removeClass('hidden-xs hidden-sm');
        });
      }

      // This variable is used in palmia.js in headcount-slider. Headcount slider needs to know when service search is loaded
      // After service search is loaded it can filter restaurants.
      serviceSearchIsLoaded = true;

      // Initialize restaurant menu related logic

      // Load menu if on restaurant page
      if (document.querySelector('.restaurant-page')) {
        import('./menu')
          .then(component => {
            const Menu = component.default;
            const menu = new Menu();
            menu.init();
          });
      }
    });

    // End service-search.js


    conferenceRoomSearch();
  }
}

export default conferenceRoomSearchMod;
